module.exports = __webpack_public_path__ + "static/img/banner@2x.fbb49aa7.be1328c.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/banner@2x.fbb49aa7.jpg
// module id = WR9M
// module chunks = 0